export enum EDIT_BUTTON_TYPE {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export interface EditInterface {
  onClick: () => void;
  ver: EDIT_BUTTON_TYPE;
  animation: boolean;
}
